// stores/data.ts
import type { Category } from "~/types/Categories";
import { defineStore } from "pinia";

export const useDataStore = defineStore("data", {
  state: () => ({
    categories: [] as Category[],
    loading: false as boolean,
    loaded: false as boolean,
  }),
  actions: {
    async fetchCategories() {
      if (this.loaded) return;
      this.loading = true;
      try {
        const { getCategories } = useCategoriesApi();
        const data = await getCategories("pagination=false");
        this.categories = data?.member ?? [];
        this.loaded = true;
      } finally {
        this.loading = false;
      }
    },
    setCategories(_categories: Category[]) {
      this.categories = _categories;
      this.loaded = true;
    },
  },
});
